import * as mt from '@/store/mutations-types.js';

/**
 * Vuex store mutations for Groups module.
 */
export default {
	[mt.SET_GROUPS]: (state, data) => {
		state.groups = data;
	},
}
